module.exports = __webpack_public_path__ + "static/img/8.ff1a315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/8.png
// module id = 0kXI
// module chunks = 2